// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileIcons-module--container--1hDEU","icon":"MobileIcons-module--icon--11iWx"};